// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ma-0";
export var leftAlign = "_ma-4";
export var listItem = "_ma-2";
export var listItemWrapper = "_ma-1";
export var operationText = "_ma-3";